export default __webpack_public_path__ + "static/media/IMG_0005.ad5d0fc1.png";